<template lang="pug">
  .list-manager
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    slot(v-else-if="paginatedList && paginatedList.rows.length > 0 && !error")
    .flex-centered.content-full-height(v-else-if="paginatedList && paginatedList.rows.length === 0")
      empty-list
    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
    paginator(v-if="!hidePagination && paginatedList && paginatedList.pages > 1" @change-page="onChangePage" :paginated-list="paginatedList")
</template>

<script>
import EmptyList from './EmptyList'
import ErrorBox from '../ErrorBox/Component'
import Paginator from './Paginator'

export default {
  components: { EmptyList, ErrorBox, Paginator },
  props: {
    error: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    paginatedList: { type: Object, default: null },
    hidePagination: { type: Boolean, default: false },
  },
  methods: {
    onChangePage(page) {
      const params = { ...this.$route.params, page }
      this.$emit('fetch-data', params)
    },
  },
}
</script>
